/**
 * @generated SignedSource<<d1418e285d395f86303947c6adcb445d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveSAMLProviderInput = {
  name: string;
};
export type RemoveSAMLProviderMutation$variables = {
  input: RemoveSAMLProviderInput;
};
export type RemoveSAMLProviderMutation$data = {
  readonly removeSAMLProvider: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly removed: {
      readonly id: string;
    } | null | undefined;
  };
};
export type RemoveSAMLProviderMutation = {
  response: RemoveSAMLProviderMutation$data;
  variables: RemoveSAMLProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveSAMLProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveSAMLProviderPayload",
        "kind": "LinkedField",
        "name": "removeSAMLProvider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveSAMLProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveSAMLProviderPayload",
        "kind": "LinkedField",
        "name": "removeSAMLProvider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b75c31dffb1f9ad300b61537edc19e9",
    "id": null,
    "metadata": {},
    "name": "RemoveSAMLProviderMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveSAMLProviderMutation(\n  $input: RemoveSAMLProviderInput!\n) {\n  removeSAMLProvider(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1240b211777d3e636cfaddacb43029bb";

export default node;
